<template>
    <div class="container">
        <h1 v-if="isAuthenticated"><fa-icon icon="home" class="me-2" />Main</h1>
        <hr v-if="isAuthenticated" />

        <div v-if="isAuthenticated" class="row">
            <div v-if="UserRoles.hasAny(['AuggieSessionView', 'AuggieSessionEdit'])" class="col-lg-6 pane">
                <button type="button" class="btn btn-secondary auggie me-2" @click.prevent="connectClicked">
                    <div>
                        <auggie-icon/>
                    </div>
                    <div class="text">
                        Connect to a Device
                    </div>
                </button>
            </div>
            <div v-if="UserRoles.hasAny(['AuggieVehicleView', 'AuggieVehicleTargetBrightnessEdit', 'AuggieVehicleEdit'])" class="col-lg-6 pane">
                <button type="button" class="btn btn-secondary cogs me-2" @click.prevent="configurationClicked">
                    <div>
                        <fa-icon icon="cogs" class="me-2" />
                    </div>
                    <div class="text">
                        Update Configuration
                    </div>
                </button>
            </div>
        </div>
        <div v-if="!isAuthenticated" class="row image-row">
            <div class="col-12 image-div">

                <img src="/img/Auggie300x230.png" alt="Auggie" class="mt-5 mb-5">

            </div>
        </div>
    </div>


</template>

<style scoped lang="scss">

@import "@/styles/variables"; // global variables

    .pane {
        padding: 2rem 8rem;
        @media (max-width: 1400px) {
            padding: 2rem 6rem;
        }
        @media (max-width: 1200px) {
            padding: 2rem 2rem;
        }
    }
    button {
        padding: 3rem;
        height: 400px;
        width:100%;
        color: $airpro-blue;
        background: white;
        border: 5px solid lightgray;
        &.cogs svg {
            font-size: 10rem;
        }
        &.auggie svg {
            width:200px;
            height:130px;
        }
        .text {
            padding-top:2rem;
            font-size: 40px;
            font-style: italic;
            font-weight: bold;
            line-height:1.3;
        }
    }
    .image-row {
        .image-div {
            text-align:center;
            img {
                width: auto;
            }
        }
    }

</style>

<script lang="ts">
import { defineComponent } from "vue";
import PageBase from "@/shared/components/common/PageBase";
import { CurrentUser } from "@/identity";
import { getMainApp } from "@/App.vue";

export default defineComponent({
    name: "Home",
    extends: PageBase,
    computed: {
        isAuthenticated(): boolean {
            return CurrentUser.isAuthenticated;
        }
    },
    methods: {
        configurationClicked(): void {
            getMainApp().routerPush("/Configuration");
        },
        connectClicked(): void {
            getMainApp().routerPush("/Connect");
        }
    }
});

</script>
